import type { ScoreContext } from "../../helpers/answer-score";

const formatScoreLines = (score?: ScoreContext) => {
	if (!score) {
		return undefined;
	}
	const criteria = score.criteria.map(
		({ label, earnedPoints, maximumScore }, index) =>
			`Criterion_${index + 1}: ${label}: ${earnedPoints}${
				maximumScore != null ? ` / ${maximumScore}` : ""
			}`,
	);
	return [
		`Score: ${score.earnedPoints} / ${score.maximumScore}`,
		...criteria,
	].join("\n");
};

export const getUserPrompt = (
	{
		stem,
		correctChoice,
		incorrectChoices,
		selectedChoice,
		explanation,
		score,
		topics,
		userResponse,
	}: {
		stem: string;
		correctChoice: string;
		incorrectChoices: string[];
		selectedChoice?: string[];
		explanation?: string;
		score?: ScoreContext;
		topics?: (string | undefined)[];
		userResponse?: string;
	},
	exam: string,
) => {
	const incorrectChoiceLines = incorrectChoices
		.map((text, index) => `Incorrect_Choice_${index + 1}: ${text}`)
		.join("\n");
	const selectedChoiceLines = selectedChoice?.length
		? selectedChoice
				.map((text, index) => `Selected_Choice_${index + 1}: ${text}`)
				.join("\n")
		: undefined;
	const scoreLines = formatScoreLines(score);
	const topicsArray = topics
		? topics
				.map((topic, index) => `Topic Level ${index + 1}: ${topic}`)
				.join("\n")
		: [];
	const text = `\`\`\`json
    {
      Topic: [${exam},
      ${topicsArray}],
      ${correctChoice ? `Correct_Choice: ${correctChoice},` : ""}
      ${incorrectChoiceLines ? `${incorrectChoiceLines},` : ""}
      ${selectedChoiceLines ? `${selectedChoiceLines},` : ""}
      ${scoreLines ? `${scoreLines},` : ""}
      Stem: ${stem},
      explanation: ${explanation},
	  	${userResponse ? `User_Response: ${userResponse},` : ""}
    }
    \`\`\``;

	return text;
};
